import { requestBackendWithChecks } from 'utils/request';

export const customHttpClient = async <T>({
  url,
  method,
  params,
  data,
  ...options
}: {
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  params?: any;
  data?: unknown;
  responseType?: string;
} & RequestInit): Promise<T> => {
  const search = new URLSearchParams(params).toString();
  const requestUrl = `${url}${search ? `?${search}` : ''}`;
  const response = await requestBackendWithChecks(requestUrl, {
    method,
    ...options,
    ...(data ? { body: JSON.stringify(data) } : {}),
  });
  const responseContentType = response.headers.get('content-type');
  if (responseContentType?.includes('application/json')) {
    return response.json();
  } else if (responseContentType?.includes('text/csv')) {
    return response.blob() as T;
  } else {
    return response.text() as T;
  }
};
